import React from 'react';

const TaskProgress = ({ progress }) => {
  const value = Number.isFinite(Number(progress))
    ? Math.min(100, Math.max(0, Math.round(Number(progress))))
    : 0;
  return (
    <div className="flex items-center gap-2 min-w-[7rem]">
      <div className="h-2 flex-1 rounded-full bg-gray-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-[#346C75]"
          style={{ width: `${value}%` }}
        />
      </div>
      <span className="text-xs text-gray-600 w-8 text-right">{value}%</span>
    </div>
  );
};

export default TaskProgress;
